import client from './axiosClient';
export const getDepartments    = ()       => client.get('/departments');
export const createDepartment  = dto      => client.post('/departments', dto);
export const updateDepartment  = (id,dto) => client.put(`/departments/${id}`, dto);
export const deleteDepartment  = id       => client.delete(`/departments/${id}`);
